import React from "react";
import ExcalidrawViewer from "../../components/ExcalidrawViewer";

const AustraliaImmediateActions: React.FC = () => (
  <ExcalidrawViewer
    filePath="/excalidraw/australia-immediate-actions-israel.excalidraw"
    title="Immediate Actions: What Australia Is Doing Right Now"
    subtitle="Active military deployments, intelligence operations, and diplomatic actions as of March 2026"
  />
);

export default AustraliaImmediateActions;
